import { INQUIRY_PROCESS_NAME, getProcess, isInquiryProcessAlias } from '../transactions/transaction';

/**
 * Resolve the Sharetribe process alias used for free pre-commitment messaging.
 * Prefers explicit inquiryProcessAlias on listing publicData, then listing type
 * inquiryTransactionType, then the listing's own alias when it is default-inquiry.
 */
export const getInquiryProcessAlias = (listing, listingTypes = []) => {
  const publicData = listing?.attributes?.publicData || {};
  const explicitAlias = publicData.inquiryProcessAlias;
  if (explicitAlias) {
    return explicitAlias;
  }

  const listingType = publicData.listingType;
  const typeConfig = listingTypes.find(conf => conf.listingType === listingType);
  const inquiryAlias = typeConfig?.inquiryTransactionType?.alias;
  if (inquiryAlias) {
    return inquiryAlias;
  }

  const listingAlias = publicData.transactionProcessAlias;
  if (listingAlias && isInquiryProcessAlias(listingAlias)) {
    return listingAlias;
  }

  return null;
};

export const getInquiryTransition = processAlias => {
  const [processName] = (processAlias || '').split('/');
  if (processName === INQUIRY_PROCESS_NAME) {
    return getProcess(processName)?.transitions?.INQUIRE_WITHOUT_PAYMENT;
  }
  return getProcess(processName)?.transitions?.INQUIRE;
};

export const buildInquiryBodyParams = (listing, listingTypes = []) => {
  const processAlias = getInquiryProcessAlias(listing, listingTypes);
  if (!processAlias) {
    throw new Error('No inquiry process configured for this listing');
  }

  const transition = getInquiryTransition(processAlias);
  if (!transition) {
    throw new Error('Inquiry transition is not available for this listing process');
  }

  return {
    transition,
    processAlias,
    params: { listingId: listing?.id },
  };
};
